import { render, staticRenderFns } from "./vime_activity_partner_entities_related.vue?vue&type=template&id=59870391"
import script from "./vime_activity_partner_entities_related.vue?vue&type=script&lang=js"
export * from "./vime_activity_partner_entities_related.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports